import { APIClient } from "api/apiCore";
import TextBox from "components/TextBox";
import { Utils } from "helpers/utils";
import { WpSliceData } from "../../../redux/workplace/wpTypes";
import React, { useDeferredValue, useEffect, useState } from "react";
import * as urls from "../../../api/urls";
import Select, { components, OptionProps, SingleValueProps } from 'react-select';
import DatePicker from "react-datepicker";
import AutoTextArea from "components/AutoTextArea";
import { FormControlLabel, Radio, RadioGroup, Switch, TextField } from "@mui/material";
import { Const, RecuranceModes } from "const";
import RecuranceControl from "./RecuranceControl";
import { DropdownOption, TaskRecurance2Data, TaskFormFieldData } from "types";
import DatePickerEx from "components/DatePickerEx";
import SelectDropdownAsyncWpTags from "components/SelectDropdownAsyncWpTags";
import RecuranceControl2 from "./RecuranceControl2";
import FormInput from "components/FormInput";
import { createSelector } from "reselect";
import { useRedux } from "hooks";

interface UserOption {
  value: string;
  label: string;
  pictureUrl: string;
  isResigned?: boolean;
}



interface TaskFormFieldProps {
  formData: TaskFormFieldData
  onFormChanged: (key: keyof TaskFormFieldData, value: any) => void;
  showTaskDescription?: boolean | null,
  showRecurance?: boolean | null,
  planFinishedDateMode?: "MANUAL" | "CAL",
  recurance?: TaskRecurance2Data | null,
  // recurance1?: TaskRecurance2Data | null,
  // recurance2?: TaskRecurance2Data | null,
  // recurance3?: TaskRecurance2Data | null,
  // onRecuranceChange?: (index: number, data: TaskRecuranceData) => void;
  onRecuranceChange?: (/*index: number,*/ patch: Partial<TaskRecurance2Data>) => void;
  selectedTagsIds?: DropdownOption[] | null;
  onTagChanged?: (values: DropdownOption[]) => void;
  onViewForcastSchedule?: () => void;
  isAssignerEditable?: boolean;

}

const TaskFormField = /*React.memo(*/({
  formData, onFormChanged, showTaskDescription = false, planFinishedDateMode = "MANUAL", showRecurance = false,
  recurance, onRecuranceChange,
  selectedTagsIds, onTagChanged, onViewForcastSchedule, isAssignerEditable = false
}: TaskFormFieldProps) => {

  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (wp: WpSliceData) => ({
      dllEmployee: wp.dllEmployee
    })
  );
  const { dllEmployee } = useAppSelector(storeData);

  // console.log('formData:', formData);

  const [recuranceIndex, setRecuranceIndex] = useState<number>(1);
  const [userDll, setUserDll] = useState<any[]>([]);
  const [assignerDdl, setAssignerDdl] = useState<any[]>([]);
  const [projectDll, setProjectDll] = useState<any[]>([]);
  const baseUrl = process.env.REACT_APP_APIURL ?? "";
  const imgProfileSize = 20;

  const getUrl = (url: string): string => {
    let urlReturn = url;
    if (url.toLowerCase().startsWith("http")) {
      urlReturn = url;
    } else {
      urlReturn = baseUrl + url;
    }
    // console.log({url, urlReturn});
    return urlReturn;
  }

  useEffect(() => {
    // console.log('xxx:', { assigner: formData.assignerId, userDll, dllEmployee });
  }, [formData.assignerId, userDll, dllEmployee]);

  useEffect(() => {
    try {
      const api = new APIClient();
      api.fnPostForm(urls.GET_DLL_VALUE_USER)
        .then(rs => {
          // console.log('GET_DLL_VALUE_USER:', rs);
          setUserDll(rs);
        })
        .catch(ex => {
          Utils.HandleException(ex, false);
        });
    } catch (e) {
      Utils.HandleException(e, false);
    }
  }, [])

  useEffect(() => {
    try {
      new APIClient().fnPostForm(urls.GET_DLL_VALUE_TKPROJECT)
        .then(rs => {
          // console.log('GET_DLL_VALUE_TKPROJECT:', rs);
          setProjectDll(rs);
        })
        .catch(e2 => Utils.HandleException(e2, false));
    } catch (e) {
      Utils.HandleException(e, false);
    }
  }, [])

  // useEffect(() => {
  //   console.log('projectDll:', projectDll);
  // }, [projectDll]);

  const getUserOption = (id: string | number | null | undefined, name?: string | null): UserOption | null => {
    if (!id) return null;
    const strId = String(id);
    return userDll.find(x => x.value == id) ?? { value: strId, label: `*ลาออก (${name ?? strId})`, pictureUrl: "", isResigned: true };
  };

  const CustomOption = (props: OptionProps<UserOption>) => {
    const { data } = props;

    return (
      <components.Option {...props}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: data.isResigned ? 'red' : undefined }}>
          <span>{data.label}</span>
        </div>
      </components.Option>
    );
  };

  const CustomSingleValue = (props: SingleValueProps<UserOption>) => {
    const { data } = props;

    return (
      <components.SingleValue {...props}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: data.isResigned ? 'red' : undefined }}>
          <span>{data.label}</span>
        </div>
      </components.SingleValue>
    );
  };

  const onTaskNameHelp = async (taskName: string) => {
    const needParse = taskName.includes('{') && taskName.includes('}') && taskName.toLowerCase().includes('date(');
    let taskName2 = taskName;
    if (needParse) {
      var rs = await new APIClient().fnPostForm(urls.WP_TK_COMPUTE_TASK_NAME, { taskName: taskName });
      if (rs && rs.taskNameParse) {
        taskName2 = rs.taskNameParse;
      }
    }
    alert([
      taskName, '🔻', taskName2,
      '<hr/>',
      '- ระบุชื่องาน พร้อมใส่รูปแบบวันที่อัตโนมัติ เช่น',
      '- งานประจำวัน <b>{date()->dd MMM yyyy}</b> -> ระบบจะสร้างเป็น <b>งานประจำวัน 13 ก.พ. 2026</b>',
      '- ในวงเล็บ date() สามารถใส่เป็น date(+1D) = วันปัจจุบัน + 1 วัน ใส่ - ก็ได้ หน่วยจะมี D,W,M,Y'
    ].join('\n')
    );
  }


  return (
    <div style={{ /*display: "flex",*/ alignItems: "center"/*, overflow: "hidden" */ }}>
      <div className="row">
        <div className="col" >
          <div className="d-flex justify-content-between">
            <div>
              {formData.createSubTaskFromTaskId && (<span className="text-warning">สร้างงานย่อย</span>)}
              {!formData.createSubTaskFromTaskId && (<span className="text-primary">ชื่องาน{showRecurance ? " ที่จะสร้างอัตโมัติ" : ""}</span>)}
            </div>
            {showRecurance && (
              <div>
                <FormControlLabel
                  control={<Switch checked={formData.enabled ?? false} onChange={(e) => onFormChanged("enabled", e.target.checked)} />}
                  label={"ใช้งาน"} />
              </div>
            )}
          </div>
          <TextBox className="form-control p-1" value={formData.taskName ?? ""} onChange={(e) => { onFormChanged("taskName", e.target.value) }}
            icon13css={showRecurance ? "fas fa-info-circle" : ""} icon13small={true} onEnter13={() => showRecurance ? onTaskNameHelp(formData.taskName ?? "") : null}
          ></TextBox>
        </div>
      </div>
      {showTaskDescription && ( 
        <div className="row">
          <div className="col">
            รายละเอียดงาน (สูงสุด 500 ตัวอักษร)
            <AutoTextArea className="form-control p-1" value={formData.taskDescription ?? ""} onChange={(e) => { onFormChanged("taskDescription", e.target.value) }} maxLength={500}></AutoTextArea>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-6" >
          ประเภทเอกสาร
          <TextBox className="form-control p-1" value={formData.docType ?? ""} onChange={(e) => { onFormChanged("docType", e.target.value) }} />
        </div>
        <div className="col-6" >
          โครงการ/project
          <Select
            options={projectDll}
            styles={Utils.GetThemeForReactSelect()}
            isClearable={true}
            menuPlacement="auto"
            menuPosition="fixed"
            menuPortalTarget={document.body}
            value={projectDll.find(x => x.value == formData.projectId) ?? null}
            placeholder={""}
            onChange={(e: any) => onFormChanged("projectId", e ? e.value : null)}
          />
        </div>
      </div>

      {showRecurance && (
        <>
          <div className="row">
            <div className="col">
              Tags
              <SelectDropdownAsyncWpTags onValueChanged={onTagChanged} selectedValues={selectedTagsIds ?? []} />
              {/* <AsyncSelect
              isMulti
              cacheOptions
              styles={Utils.GetThemeForReactSelect()}
              defaultOptions={false}
              loadOptions={loadOptions}
              value={value}
              onChange={(v) => setValue(v as Option[])}
              placeholder="Search tag..." /> */}
            </div>
          </div>

          {/* <div className="row">
            <div className="col">
              <div className="mt-3">
                <span className={"wp-tag-filter hand mb-2 hover badge-task-status-todo " + (recuranceIndex == 1 ? "selected" : "")} onClick={() => setRecuranceIndex(1)}>🕐การทำซ้ำ #1</span>
                <span className={"wp-tag-filter hand mb-2 hover badge-task-status-todo " + (recuranceIndex == 2 ? "selected" : "")} onClick={() => setRecuranceIndex(2)}>🕓การทำซ้ำ #2</span>
                <span className={"wp-tag-filter hand mb-2 hover badge-task-status-todo " + (recuranceIndex == 3 ? "selected" : "")} onClick={() => setRecuranceIndex(3)}>🕝การทำซ้ำ #3</span>
              </div>
              {recuranceIndex == 1 && (<RecuranceControl data={recurance1} onPartialChanged={(patch) => onRecuranceChange?.(1, patch)} />)}
              {recuranceIndex == 2 && (<RecuranceControl data={recurance2} onPartialChanged={(patch) => onRecuranceChange?.(2, patch)} />)}
              {recuranceIndex == 3 && (<RecuranceControl data={recurance3} onPartialChanged={(patch) => onRecuranceChange?.(3, patch)} />)}
            </div>
          </div> */}

          <div className="row">
            <div className="col">
              <div className="d-flex justify-content-between">
                <div>
                  กำหนดเสร็จ
                  <span className="ms-2 text-primary hover hand" onClick={onViewForcastSchedule}><u>[ทดสอบคำนวณตารางงาน]</u></span>
                </div>
                <div>
                  งานล่าสุด [{recurance?.lastTaskFinishedDate ? (<>{Utils.GetDMY(recurance?.lastTaskFinishedDate, true)}</>) : (<>ยังไม่มี</>)}]
                </div>
              </div>
              <div className="wp-tag-toolbox-mem">
                <RecuranceControl2 data={recurance} onPartialChanged={(patch) => onRecuranceChange?.(/*1,*/ patch)} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              Effective Date
              <DatePickerEx isDisabled={false} selectedDate={recurance?.startDate ?? null} onDateChanged={(date) => onRecuranceChange?.(/*-1,*/ { startDate: date })} />
            </div>
            <div className="col">
              Expired Date
              <DatePickerEx isDisabled={false} selectedDate={recurance?.expireDate ?? null} onDateChanged={(date) => onRecuranceChange?.(/*-1,*/ { expireDate: date })} />
            </div>
          </div>
        </>
      )}
      <div className="row">
        <div className="col-6">
          ผู้มอบหมาย
          {/* <TextBox className="form-control p-1" onChange={(e) => { }}></TextBox> */}
          <Select<UserOption>
            options={userDll}
            styles={Utils.GetThemeForReactSelect()}
            isClearable={false}
            isDisabled={!isAssignerEditable}
            menuPlacement="auto"
            menuPosition="fixed"
            menuPortalTarget={document.body}
            components={{
              Option: CustomOption,
              SingleValue: CustomSingleValue,
            }}
            value={getUserOption(formData.assignerId, formData.assignerName)}
            isOptionDisabled={(option) => option.isResigned === true}
            onChange={(e: any) => onFormChanged("assignerId", e?.value ?? null)}
          />
        </div>

        <div className="col-6">
          เจ้าของงาน
          <Select<UserOption>
            options={userDll}
            styles={Utils.GetThemeForReactSelect()}
            isClearable={true}
            menuPlacement="auto"
            menuPosition="fixed"
            menuPortalTarget={document.body}
            components={{
              Option: CustomOption,
              SingleValue: CustomSingleValue,
            }}
            value={getUserOption(formData.respondId, formData.respondName)}
            isOptionDisabled={(option) => option.isResigned === true}
            onChange={(e: any) => onFormChanged("respondId", e?.value ?? null)}

          />
        </div>
        {/* <div className="col">
          ความเร่งด่วน
          <TextBox className="form-control p-1" onChange={(e) => { }}></TextBox>
        </div> */}
        {/* <div className="col">
          วันเริ่มทำ
          <TextBox className="form-control p-1" onChange={(e) => { }}></TextBox>
        </div> */}
        <div className="col-6">
          ผู้ขอ
          <Select<UserOption>
            options={userDll}
            styles={Utils.GetThemeForReactSelect()}
            isClearable={true}
            menuPlacement="auto"
            menuPosition="fixed"
            menuPortalTarget={document.body}
            components={{
              Option: CustomOption,
              SingleValue: CustomSingleValue,
            }}
            value={getUserOption(formData.requestBy, formData.requesterName)}
            isOptionDisabled={(option) => option.isResigned === true}
            onChange={(e: any) => onFormChanged("requestBy", e?.value ?? null)}
          />
        </div>
        <div className="col-6">
          {planFinishedDateMode == "MANUAL" && (
            <>
              กำหนดเสร็จ
              <DatePicker
                selected={formData.planFinishedDate}
                onChange={(date: any) => onFormChanged("planFinishedDate", date)}
                dateFormat={"dd/MM/yyyy"} isClearable className="form-control p-1" portalId="root-portal"></DatePicker>
            </>
          )}
          {/* {planFinishedDateMode == "CAL" && (
            <>
              <span>
                &nbsp;&nbsp;ภายใน {(formData.finishedByUnit == "M0" || formData.finishedByUnit == "M1") ? "วันที่" : ""}
              </span>

              <div className="d-flex">
                <select className="form-control" value={formData.finishedByNum?.toString()} onChange={(e) => onFormChanged("finishedByNum", e?.target?.value)}>
                  <option value=""></option>
                  {Array.from({ length: Const.DAY_MONTH_END_NEXT }, (_, i) => {
                    const val = i + 1;
                    const text = val == Const.DAY_MONTH_END ? "สิ้นเดือน" : val == Const.DAY_MONTH_END_NEXT ? "สิ้นเดือนถัดไป" : val;
                    return (<option key={val} value={val}>{text}</option>)
                  })}
                </select>
                {(formData.finishedByNum != Const.DAY_MONTH_END && formData.finishedByNum != Const.DAY_MONTH_END_NEXT) && (
                  <select className="form-control" value={formData.finishedByUnit ?? ""} onChange={(e) => onFormChanged("finishedByUnit", e?.target?.value)}>
                    <option value=""></option>
                    <option value="D">วัน</option>
                    <option value="W">อาทิตย์</option>
                    <option value="M">เดือน</option>
                    <option value="M0">ของเดือน</option>
                    <option value="M1">เดือน ถัดไป</option>
                  </select>
                )}
              </div>
            </>
          )} */}
          {planFinishedDateMode == "CAL" && (
            <>
              สร้างงานก่อนครบกำหนด
              <div className="d-flex justify-content-between">
                <TextBox type="number" className="form-control" minValue={1} clearable={false} value={recurance?.createTaskBefore?.toString()} onChange={(e) => onRecuranceChange?.({ createTaskBefore: Utils.ToNumber(e.target.value, null) })} />
                <select className="form-control" value={recurance?.createTaskBeforeUnit ?? "D"} onChange={(e) => onRecuranceChange?.({ createTaskBeforeUnit: e.target.value as "D" | "W" | "M" | null })}>
                  <option value="D">วัน</option>
                  <option value="W">อาทิตย์</option>
                  <option value="M">เดือน</option>
                </select>
              </div>
            </>
          )}
        </div >
        {/* <div className="col">
          สถานะ
          <TextBox className="form-control p-1" onChange={(e) => { }}></TextBox>
        </div> */}
      </div>
    </div >
  );
}/*)*/;

export default TaskFormField;